import { axiosServicesV1, axiosServicesV3 } from 'utils/services';

export const getTLSAllLicencesSearch = async (licence: any) => {
    try {
        const response = await axiosServicesV3.post('/api/IRISLicence/v1/licencesearchfe', licence);
        if (response) {
            return response?.data;
        }
    } catch (error) {
        console.error(error);
    }
    return [];
};

export const getTLSAllLicencesExport = async (licence: any) => {
    try {
        const response = await axiosServicesV3.post('/api/IRISLicence/v1/licencesearchfe/export', licence, {
            responseType: 'blob',
            headers: {
                Accept: 'application/octet-stream'
            }
        });
        if (response) {
            return response?.data;
        }
    } catch (error) {
        console.error(error);
    }
    return [];
};


export const getOthersAllLicencesSearch = async (licence: any) => {
    try {
        const response = await axiosServicesV3.post('/api/IRISLicence/v1/licencesearchfe', licence);
        if (response) {
            return response?.data;
        }
    } catch (error) {
        console.error(error);
    }
    return [];
};

export const getRCAListForLanguageProficiency = async (languageCode: string, pageNumber: number, pageRowSize: number, otherLanguage?: string) => {
    try {
        let url = `/data_iris/D_GetRCAListForLanguageProficiency?LanguageCode=${languageCode}&PageNumber=${pageNumber}&PageRowSize=${pageRowSize}`;
        
        // Only add OtherLanguage parameter if it's provided (when Others is selected)
        if (otherLanguage) {
            url += `&OtherLanguage=${encodeURIComponent(otherLanguage)}`;
        }
        
        const response = await axiosServicesV1.get(url);
        if (response) {
            return response?.data;
        }
    } catch (error) {
        console.error(error);
        throw error;
    }
    return null;
};
